<template>
	<div class="email-list-wrap">
		<div class="bread">
			<router-link class="bread-item" to="/">上上签</router-link>
			<div class="bread-arrow">&gt;</div>
			<router-link class="bread-item" to="/orders">订单管理</router-link>
			<div class="bread-arrow">&gt;</div>
			<router-link class="bread-item" :to="'/orders/detail/'+Order.user_order_id">订单详情</router-link>
			<div class="bread-arrow">&gt;</div>
			<a class="bread-item">邮寄资料清单</a>
		</div>

		<div class="mail-panel">
			<div class="mail-header">
				<span class="title">邮寄资料清单</span>
        <span class="mail-tip">带 <span class="fg-red">*</span> 为必备资料</span>
			</div>

			<div class="mail-content">
        <template v-for="(type, key, index) in infos">
          <div class="mail-item" v-if="type.materials.paper.length > 0" :key="index">
            <div class="mail-title">
              <div class="mail-names">
                <span class="mail-identity">{{key}} : </span><span class="names">{{type.names.join('、')}}</span>
              </div>
            </div>

            <div class="mail-material" v-for="(materials, materialKey, i) in type.materials" :key="i">
              <div class="material-item" v-for="(material, j) in materials" :key="j">
                <div class="material-name"><span class="required-field" v-if="material.require">*</span><span v-text="material.name"></span></div>
                <div class="material-detail">
                  <ul v-if="material.attention.split('\n')[0]">
                    <li v-for="(at, k) in material.attention.split('\n')" :key="k">{{at}}</li>
                  </ul>
                </div>
                <div class="material-action">
                  <a @click="showImage(material.sample)" class="el-button el-button--primary is-plain" v-if="material.sample && material.sample.length > 0">查看样例</a>
                  <a :href="material.template" class="el-button el-button--primary" v-if="material.template">下载模板</a>
                </div>
              </div>
            </div>
          </div>
        </template>
			</div>
		</div>

    <!-- 多图预览弹窗 -->
    <multi-image-preview v-model="multiImagePreviewOpen" :multiImageArray="multiImageArray"></multi-image-preview>
	</div>
</template>

<script>
import Order from '../libs/order.js';
import User from '../libs/user';
import multiImagePreview from '../components/common/multi-image-preview';

export default {
  components: {
    multiImagePreview,
  },
  data() {
    return {
      oid: +this.$route.params.oid,
      Order,
      infos: {},
      infoTypes: {
        elec: '电子资料',
        paper: '邮寄资料',
      },
      User,
      multiImagePreviewOpen: false,
      multiImageArray: [],
    };
  },
  methods: {
    // 打开多图预览弹窗
    showImage(data) {
      this.multiImagePreviewOpen = true;

      // 后端部分接口资料样例 sample 返回的仍然是字符串，而不是数组，这里先做一个兼容处理。
      if (typeof data === 'string') {
        const buildData = [];
        buildData.push(data);
        this.multiImageArray = buildData;
      } else {
        this.multiImageArray = data;
      }
    },
  },
  beforeCreate() {
    if (!Order.user_order_id) {
      this.$router.replace({ name: 'orderDetail', params: { oid: this.$route.params.oid } });
    }
  },
  created() {
    Order.applicant && Order.applicant.forEach((ap) => {
      if (!this.infos[ap.identity]) {
        this.infos[ap.identity] = {
          names: [],
          materials: {
            paper: [],
          },
        };

        ap.material.material_required.forEach((m) => {
          m.require = true;
          m.name = m.elec_name || m.paper_name;

          if (m.attr === 1) {
            this.infos[ap.identity].materials.paper.push(m);
          }
        });

        ap.material.material_optional.forEach((m) => {
          m.require = false;
          m.name = m.elec_name || m.paper_name;

          if (m.attr === 1) {
            this.infos[ap.identity].materials.paper.push(m);
          }
        });
      }

      this.infos[ap.identity].names.push(ap.applicant_name);
    });
  },
};
</script>

<style lang="less" scoped>
@import  '../assets/less/variable';
.email-list-wrap {
	width: 920px;
	margin: auto;
	padding-bottom: 100px;

	.mail-panel {
		background-color: white;
		box-shadow:0 1px 7px -3px #555;
	}

	.mail-header {
		position: relative;
		padding:15px 20px;
		background-color:#fbfbfb;
		.title {
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
    }
    .mail-tip {
      font-size: 12px;
      line-height: 12px;
      color: #777;
      margin-left: 10px;
    }
	}

	.mail-content {
		padding: 1px 30px 1px 30px;
	}

	.mail-item {
    margin: 30px 0;
		.mail-names {
      font-size: 14px;
      line-height: 14px;
      color: #333;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      line-height: 18px;
      .mail-identity {
        font-weight: 500;
        position: relative;
        padding-right: 10px;
        &::after {
          content: "";
          display: block;
          width: 3px;
          height: 16px;
          background-color: @main;
          position: absolute;
          border-radius: 1px;
          bottom: 1px;
          left: -10px;
        }
      }
      .names {
        font-weight: 200;
        flex: 1;
      }
    }
	}

	.mail-material {
    padding-left: 12px;
    .material-item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px 0;
      border-bottom: 1px solid #f0f0f0;

      .material-name {
        position: relative;
        width: 133px;
        padding-right: 23px;
        font-size: 14px;
        color: #333;
        width: 130px;
        line-height: 1.5;
        .required-field{
          color: #ff5a60;
          position: absolute;
          left: -12px;
          top: 4px;
          font-size: 14px;
          line-height: 14px;
        }
      }

      .material-detail {
        font-size: 12px;
        color: #777;
        line-height: 1.5;
        flex: 1;
        ul {
          // list-style-type: disc;
          padding-left: 25px;
        }

        li + li {
          margin-top: 8px;
        }
      }

      .material-action {
        text-align: right;
        width: 206px;
      }
    }
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderMailList.vue